import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { getGuideVotes } from '../services/guideService';
import { FaArrowUp } from 'react-icons/fa';
import '../styles/GuideHeaderInfo.css';

const GuideHeaderInfo = ({ guidePath }) => {
    const { idToken: token } = useAuth(); // Token can be null if logged out
    const [upvotes, setUpvotes] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const fetchVotes = useCallback(async () => {
        try {
            setIsLoading(true);
            // Pass token; it's ok if it's null for logged-out users
            const data = await getGuideVotes(guidePath, token);
            setUpvotes(data.upvotes || 0);
        } catch (err) {
            console.error("Could not load vote count for header:", err);
        } finally {
            setIsLoading(false);
        }
    }, [guidePath, token]);

    useEffect(() => {
        fetchVotes();
    }, [fetchVotes]);

    // Render nothing while loading or if there are no upvotes
    if (isLoading || upvotes === 0) {
        return null;
    }

    return (
        <div className="guide-header-info">
            <div className="upvote-display">
                <FaArrowUp />
                <span>
                    {upvotes} {upvotes === 1 ? 'person' : 'people'} found this helpful
                </span>
            </div>
        </div>
    );
};

export default GuideHeaderInfo;
